export default {
  before: {
    all: [
      context => {
        context.params.headers = {
          ...context.params.headers,
          'Accept-Language': '*', // Request every translation available
        }
      },
    ],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },

  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },

  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
}



// WEBPACK FOOTER //
// ./src/app.hooks.js